import React, { useState, useMemo } from "react";
import { Card } from "react-bootstrap";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import ReviewClinicModal from "./ReviewClinicModal";

const { Header: CardHeader, Body: CardBody, Title: CardTitle } = Card;

const DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
});

const PendingUpdateRequests = ({ data, totalCount, refetch }) => {

    const [selectedRequestId, setSelectedRequestId] = useState(null);

    const frameworkComponents = useMemo(() => ({
        actionCellRenderer: (params) => {

            const handleViewDetails = () => {
                setSelectedRequestId(params.data.id);  // Open modal instead of navigate
            };

            return (
                <button
                    onClick={handleViewDetails}
                    className="docg-save-btn"
                    style={{ padding: "0px 14px", borderRadius: "24px" }}
                >
                    Review
                </button>
            );
        },
    }), []);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        // minWidth: 150,
        suppressMovable: true,
    };

    return (
        <>
            <Card className="docg-card">
                <CardHeader className="customCardHeader d-flex justify-content-between">
                    <CardTitle className="customCardTitle">
                        Clinic Update Requests
                        {typeof totalCount === "number"
                            ? ` (${data?.length ?? 0} pending of ${totalCount} total)`
                            : data?.length
                                ? ` (${data.length})`
                                : ""}
                    </CardTitle>

                    {/* Refresh button */}
                    <button onClick={refetch} className="docg-save-btn"                    >
                        Refresh
                    </button>
                </CardHeader>

                <CardBody className="docg-card-body p-0">
                    {/* AG-Grid Table */}
                    <div className="ag-theme-alpine" style={{ height: "100%", minHeight: "200px", width: "100%" }}>
                        <AgGridReact
                            rowData={data}
                            defaultColDef={defaultColDef}
                            rowHeight={60}
                            frameworkComponents={frameworkComponents}
                            pagination={true}
                            paginationPageSize={10}
                            animateRows={true}
                        >
                            {/* Column: Clinic Name */}
                            <AgGridColumn
                                headerName="Clinic Name"
                                field="clinicName"
                                tooltipField="clinicName"
                            />

                            {/* Column: Requested By */}
                            <AgGridColumn
                                headerName="Requested By"
                                field="requestedBy"
                                tooltipField="requestedBy"
                            />

                            {/* Column: Requested At (with date formatting) */}
                            <AgGridColumn
                                headerName="Requested Date"
                                field="requestedAt"
                                valueFormatter={(params) => params.value ? DATE_FORMATTER.format(new Date(params.value)) : "-"}
                            />

                            {/* Column: Status */}
                            <AgGridColumn
                                headerName="Status"
                                field="status"
                                tooltipField="status"
                                cellStyle={{ color: '#C06C84', fontWeight: "500" }}
                            />

                            {/* Column: Action */}
                            <AgGridColumn
                                headerName="Action"
                                cellRenderer="actionCellRenderer"
                                sortable={false}
                                filter={false}
                                minWidth={120}
                            />
                        </AgGridReact>
                    </div>
                </CardBody>
            </Card >

            <ReviewClinicModal
                show={selectedRequestId !== null}
                requestId={selectedRequestId}
                onClose={() => setSelectedRequestId(null)}
                refetch={refetch}
            />
        </>
    );
};

export default PendingUpdateRequests;